export default __webpack_public_path__ + "static/media/subscriptions.82fdb224.svg";